module.exports = __webpack_public_path__ + "img/about-patent1.fe8abcd.png";